import { CheckoutStepKey } from '../types/checkout-common';
import { Subject } from 'rxjs';
import { US_MOBILE_REGEX, US_ZIP_CODE_REGEX } from '../constants/regex';

export const processingForm = new Subject<CheckoutStepKey>();

export const ValidateUSZipCode = (value: string) => US_ZIP_CODE_REGEX.test(value);

export const validateUSPhoneNumber = (phoneNumber: string) => US_MOBILE_REGEX.test(phoneNumber);

export const scrollIntoViewWithOffset = (selector: HTMLElement | null, offset?: number) => {
  if (!selector) {
    return;
  }
  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      top:
        selector.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        (offset ?? 150),
    });
  }, 0);
};
